import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Twitter, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-midnight-ink border-t border-prism-violet/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="space-y-4">
            <img
              src="https://customer-assets.emergentagent.com/job_multi-brand-portal/artifacts/dkrj21tk_Studio%20Prism%20Entertainment%20Logo.png"
              alt="Studio Prism Entertainment"
              className="h-12 w-auto"
            />
            <p className="text-iridescent-silver text-sm leading-relaxed">
              Illuminate the unseen. Where dreams transform into stardom through cutting-edge training and innovative approaches.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-iridescent-silver hover:text-prism-violet transition-colors"><Instagram size={20} /></a>
              <a href="#" className="text-iridescent-silver hover:text-prism-violet transition-colors"><Twitter size={20} /></a>
              <a href="#" className="text-iridescent-silver hover:text-prism-violet transition-colors"><Youtube size={20} /></a>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="text-white font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="" className="text-iridescent-silver hover:text-white transition-colors">Home</Link></li>
              <li><Link to="apply" className="text-iridescent-silver hover:text-white transition-colors">Apply Now</Link></li>
              <li><a href="#" className="text-iridescent-silver hover:text-white transition-colors">About Us</a></li>
              <li><a href="#" className="text-iridescent-silver hover:text-white transition-colors">Success Stories</a></li>
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="text-white font-semibold">Programs</h3>
            <ul className="space-y-2">
              <li className="text-iridescent-silver">Vocal Training</li>
              <li className="text-iridescent-silver">Dance Choreography</li>
              <li className="text-iridescent-silver">Performance Coaching</li>
              <li className="text-iridescent-silver">Media Training</li>
              <li className="text-iridescent-silver">Artist Development</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="text-white font-semibold">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3"><Mail size={16} className="text-prism-violet" /><span className="text-iridescent-silver text-sm">studioprismentertainment@gmail.com</span></div>
              <div className="flex items-center space-x-3"><Phone size={16} className="text-prism-violet" /><span className="text-iridescent-silver text-sm">+82 2-1234-5678*</span></div>
              <div className="flex items-start space-x-3"><MapPin size={16} className="text-prism-violet mt-0.5" /><span className="text-iridescent-silver text-sm">123 Gangnam-daero*<br/>Seoul, South Korea</span></div>
              <div className="mt-3 pt-2 border-t border-prism-violet/20">
                <p className="text-xs text-iridescent-silver/70">*Phone number and address are fictional</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-prism-violet/20 pt-8 mt-12">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-iridescent-silver text-sm">© 2024 Studio Prism Entertainment. All rights reserved.</p>
            <div className="flex space-x-6">
              <a href="#" className="text-iridescent-silver hover:text-white text-sm transition-colors">Privacy Policy</a>
              <a href="#" className="text-iridescent-silver hover:text-white text-sm transition-colors">Terms of Service</a>
            </div>
          </div>
          <div className="mt-6 pt-4 border-t border-prism-violet/10">
            <p className="text-xs text-iridescent-silver/60 text-center leading-relaxed"><strong>Disclaimer:</strong> All names, characters, businesses, places, events, locales, and incidents mentioned on this website are solely for fictional roleplay purposes. Any resemblance or likeness to any real life personages, organizations, or entities are purely coincidental.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;